<template>
  <div>
    <div class="flex flex-col justify-center relative items-center pb-1  p/l-2 " v-mousedown-outside="changeHandler"  @click="isOpen = !isOpen">
   
      <div class="mr-0 mb-1 toollabel" >BRUSH SIZE</div>

      <!-- <transition name="fade" > -->
        <div
          id="sliderwrap"
          v-show="isOpen"
          class="flex flex-col absolute items-center bottom-0 z-0 pb-12 bg-white rounded-full w-12 lg:w-12 border border-solid border-red-100"
        >
          <div class="text-md">+</div>
          <input
            type="range"
            v-model="value"
            orient="vertical"
            @input="emitValue"
            min="1"
            max="40"
            class="syl-slider h-40 mx-2"
            @change="changeHandler"
          />
          <div class="text-md ">-</div>
        </div>
      <!-- </transition> -->
      <button
        class="w-12 h-12 lg:h-12 lg:w-12 rounded-full flex boox-border items-center justify-center m/2 p-1 border border-double border-red-100 p-1"
      >
        <div
          class="sizeIndicator rounded-full z-10 flex items-center justify-center p-1 bg-red-100"
          :style="{
            width: value + 'px',
            height: value + 'px',
          }"
        ></div>
        <!-- backgroundColor: color, -->
      </button>

    </div>
  </div>
</template>

<script>


export default {
  name: "BrushSize",
  props: ["color"],
  directives: {
    // ClickOutside,
  },
  data() {
    return {
      value: 3,
      isOpen: false,
    };
  },
  methods: {
    changeHandler() {
      this.isOpen = false;
    },
    emitValue() {
      this.$emit("input", this.value);
    },
    toggleSlider() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
input[type="range"]{
  /* writing-mode: bt-lr; IE */
  /* -webkit-appearance: slider-vertical; WebKit */
  /* height: 100%; */
  padding: 0 5px;
}

.syl-slider {
  -webkit-appearance: none;
  height: 2px;
  /* height: 25px; */
  background: #000;
  outline: none;
  border: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.syl-slider:hover {
  opacity: 1;
}

.syl-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  /* width: 16px; */
  /* height: 16px; */
  background: #19324f;
  cursor: pointer;
  border-radius:5px;
}

.syl-slider::-moz-range-thumb {
  /* width: 5px;/ */
  /* height: 25px; */
  /* background: #4caf50; */
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
}

.outer{
  border-color:#19324f;
}

.sizeIndicator{
  /* border:2px solid #19324f; */
  /* background-color:#19324f; */
  /* padding:0px; */
}

#sliderwrap{


}

</style>
